import { Col, Container, Row, Stack } from "react-bootstrap";

const HireReactJSDeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Expert React.js Developers to Build Fast, Scalable Web Applications
                        </h2>
                        <p>
                            Need a modern, responsive web application that delivers excellent user experiences? Our skilled React.js developers specialize in building dynamic, component-driven UIs optimized for performance, usability, and scalability.
                        </p>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire React.js Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>Expertise in Modern React</b>
                                <p>
                                    From hooks and context to advanced state management and performance optimization, we leverage the latest React features to deliver robust applications.
                                </p>
                            </li>
                            <li>
                                <b>Reusable & Scalable Components</b>
                                <p>
                                    We write clean, maintainable code with reusable components that scale with your business and reduce future development time.
                                </p>
                            </li>
                            <li>
                                <b>Focus on UI/UX</b>
                                <p>
                                    Our developers collaborate closely with designers to ensure pixel-perfect, user-friendly interfaces that increase engagement and retention.
                                </p>
                            </li>
                            <li>
                                <b>Integration & API Handling</b>
                                <p>
                                    Seamless integration with RESTful APIs, GraphQL, and third-party services to deliver full-stack functionality.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Models</b>
                                <p>
                                    Hire React.js developers on a full-time, part-time, or hourly basis to meet your unique project needs.
                                </p>
                            </li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>
                            Our React.js Development Services
                        </h2>
                        <ul>
                            <li>Custom React.js Web Development</li>
                            <li>Single Page Application (SPA) Development</li>
                            <li>Progressive Web App (PWA) Development</li>
                            <li>Frontend Architecture & Component Libraries</li>
                            <li>API Integration & State Management</li>
                            <li>Migration from Legacy Systems to React</li>
                            <li>Performance Optimization & Maintenance</li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>
                            Let’s Build Something Great with React.js
                        </h2>
                        <p>
                            Ready to turn your vision into a high-performing web app? Contact us today for a free consultation and detailed proposal.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
};

export default HireReactJSDeveloperContent;
